var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelNikeSm = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 6,
  viewBox: "0 0 14 6",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FAB14D",
  fillRule: "evenodd",
  d: "M0 4.014c-.003.415.116.777.402 1.051.41.395.864.534 1.315.535.658 0 1.313-.294 1.825-.522C4.405 4.694 13.941.092 13.941.092c.092-.051.075-.115-.04-.083C13.854.02 3.519 3.134 3.519 3.134q-.302.095-.602.096c-.794.005-1.5-.485-1.495-1.517.002-.404.114-.892.371-1.465C.883 1.438.01 2.912 0 4.014"
})));
export default SvgChannelNikeSm;